import {Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import {Facet, FacetValue} from "../../model/ListingModel";
import {Observable, Subscription} from "rxjs";
import {ListingService} from "../../services/listing.service";

@Component({
  selector: 'v-facet',
  templateUrl: './facet.component.html'
})
export class FacetComponent implements OnInit, OnDestroy {
  @Input() facet: Facet;
  @Input() breakpoint$: Observable<string>;
  @Input() showSearch = false;
  @Input() processing;
  @Output() submitFacets: EventEmitter<boolean> = new EventEmitter();
  @Output() closeFacets: EventEmitter<void> = new EventEmitter();
  private subscriptions: Subscription = new Subscription;
  elements: FacetValue[];
  limit = 8;
  end = this.limit;
  showMore = true;
  contentVisible = false;
  searching = false;
  selectedCounter = 0;
  showPickButton = false;

  constructor(private listingService: ListingService) {
  }

  ngOnInit() {
    this.elements = [...this.facet.values];
    const selectedFacets = this.elements.filter((el: FacetValue) => el.selected === true).map((el, index) => {
      return {checked: el.selected, name: `${this.facet.code}-${el.code}`, key: this.facet.webname, value: el.name}
    });

    this.subscriptions.add(this.breakpoint$.subscribe(breakpoint => {
      const mobile = breakpoint === 'mobile';

      if(mobile) {
        this.contentVisible = false;
        this.limit = 10;
        this.end = this.limit;
        this.showPickButton = true;
      }
      else {
        this.contentVisible = true;
        this.limit = 8;
        this.end = this.limit;
        this.showPickButton = false;
        if(this.isSelectedInvisible(this.limit)) this.toggleElementsVisibility();
      }
    }));

    if(selectedFacets.length) {
      const selected = selectedFacets.length;
      this.selectedCounter = selected;

      if(this.facet.code === 'brandName') this.contentVisible = true;
    }
  }

  isSelectedInvisible(limit) {
    return this.elements.some((facet, index) => index >= limit && facet.selected);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public getCodeTracking(index: number, facet: FacetValue) {
    return facet.code;
  }

  filterItems(_name: string) {
    const name = _name;

    this.elements = [...this.facet.values].filter((item: FacetValue) => item.name.toLowerCase().startsWith(name.toLowerCase()));
    if(name?.length) {
      this.searching = true;
      this.end = this.elements.length;
    } else {
      this.searching = false;
      this.end = this.limit;
    }
  }

  checkFacet(_facetCode, _group, _facet, _ev) {
    const checked = _ev.target.checked;
    const keyName = `${_facetCode}-${_facet}`;
    const key = _group;
    const value = _facet;
    const closeFacetsOnMobile = _facetCode !== 'brandName';

    this.listingService.toggleFacetToSelected({checked, keyName, key, value});
    this.submitFacets.emit(closeFacetsOnMobile);
  }

  toggleElementsVisibility() {
    if(this.end === this.limit) {
      this.end = this.elements.length;
      this.showMore = false;
    } else {
      this.end = this.limit;
      this.showMore = true;
    }
  }

  toggleContentVisibility() {
    this.contentVisible = !this.contentVisible;
  }
}
